<template>
    <div v-if="isShow && platform != 'chuangyue'" class="content" @click.stop="goAppDownLoad()">
        <img class="game_img" :src="icon_url" />
        <p>APP内查看</p>
        <img @click.stop="changeIsShow()" class="del_img" src="@/assets/images/app_download/btn_del.png" />
    </div>
    <!-- <div v-if="isShow && platform == 'chuangyue'" class="content_chuangyue" @click.stop="goAppDownLoad()">
        <img class="game_img" :src="icon_url" />
        <p>APP内查看</p>
        <img @click.stop="changeIsShow()" class="del_img" src="@/assets/images/app_download/btn_del_chuangyue.png" />
    </div> -->
</template>

<script lang="js">
import { defineComponent, ref, reactive, toRefs, watch, onBeforeMount, onMounted, onActivated, onDeactivated, onBeforeUnmount, computed} from 'vue';
import { useStore } from 'vuex';
import { onBeforeRouteLeave } from "vue-router"
import Util from '@/assets/js/lib/util';
import router from '@/router';

export default defineComponent({
    name: 'AppDownload',
    components: {  },
	props: ['deviceId'],
    setup(props, { attrs, slots, emit }) {
        const store = useStore();
        const state = reactive({
            util: new Util(),
            icon_url: '',
            sdkInfo: computed(() => store.state.sdkInfo),
            platform: window.Config.platform
        }); //变量
        const data = reactive({
            isShow: false, //按钮展示
        }); //数据

        const methods = {
            back: () => router.back(),
            goState: o => {
                router.push(o)
            },
            changeIsShow() {
                store.commit('changeIsShowDownload', false)
            },
            goAppDownLoad() {
                methods.goState({name: 'appDownload'})
            }
        } //需要对外暴露的方法

        const getVersion = async () => {
            try{
                const res = await state.util.getJson2("/info/v1/gamehub_version", "GET", {
                }, false);
                if(res.code == 0) {
                    try{
                        state.icon_url = res.data.icon || ''
                    }catch(e){
                        console.log(e)
                    }
                }else {
                    if(res.message !== '') {
                        window.Components.toast(res.message)
                    }
                }
            }catch(e){
                console.log(e)
            }
        }

        onMounted(async () => {
            try{
                await Promise.all([getVersion()]);
            }catch(e){
                console.log(e)
            }

            let isAPPClient = false;
            let isIOSClient = false;
            let isAndroidClient = false;

            try {
                isAPPClient = state.util.isAPPClient();

                if(isAPPClient) {
                    try {
                        await state.util.getAppClient();
                    } catch (error) {
                        console.error('获取APP客户端信息失败:', error);
                    }

                    try {
                        isIOSClient = state.util.isIOSClient();
                        isAndroidClient = state.util.isAndroidClient();
                    } catch (error) {
                        console.error('获取客户端类型失败:', error);
                    }
                }
            } catch (error) {
                console.error('检查是否APP客户端失败:', error);
            }

            // if(!isAPPClient || (isAndroidClient && state.sdkInfo.isSdkEnv)) {
            //     //浏览器或者安卓sdk情况下显示
            //     data.isShow = computed(() => store.state.isShowDownload);
            //     return;
            // }
            if(!isAPPClient) {
                //仅浏览器时显示，其他情况隐藏
                data.isShow = computed(() => store.state.isShowDownload);
                return;
            }
            data.isShow = false;
        });

        onActivated(() => {
        });

        onDeactivated(() => {
        });

        onBeforeUnmount(() => {
        })

        onBeforeRouteLeave((to, from) => {

        });

        return {
            ...toRefs(state),
            ...toRefs(data),
            ...methods,
        };
    },
});
</script>

<style lang="less" scoped>
@charset "utf-8";
@import "./AppDownload.less";
</style>
